import { render, staticRenderFns } from "./_OneLiner.vue?vue&type=template&id=202f2897&"
import script from "./_OneLiner.vue?vue&type=script&lang=ts&"
export * from "./_OneLiner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports